import React, { useRef } from 'react';
import { Pointer, PointerProps } from './Pointer';
import { AngleMode, getNewAngleByEvent, getRotatedPosition } from './utils';

export interface AngleProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange' | 'color'> {
    prefixCls?: string;
    width?: number;
    height?: number;
    angle: number;
    pointer?: ({ prefixCls, left, top }: PointerProps) => JSX.Element;
    onChange?: (angle: number) => void;
}

/** 鼠标滑动按15度吸附 */
const ANGLE_MODE_BY_MOUSE_MOVE: AngleMode = '15deg';

const Angle: React.FC<AngleProps> = (props) => {
    const {
        prefixCls = 'c-color-angle',
        pointer,
        className,
        style,
        width = 32,
        height = 32,
        angle = 0,
        onChange,
        ...other
    } = props;

    const wrapperRef = useRef(null);

    const rotatedPosition = getRotatedPosition(angle, width);

    const comProps = {
        top: '0',
        left: '0',
    };
    function handleMousedown(evn: MouseEvent | React.MouseEvent) {
        const angle = getNewAngleByEvent(
            evn,
            wrapperRef.current as unknown as HTMLDivElement,
            ANGLE_MODE_BY_MOUSE_MOVE,
        );
        if (typeof angle === 'number') {
            onChange && onChange(angle);
            addMouseListeners();
        }
    }

    function addMouseListeners() {
        document.addEventListener('mousemove', handleMousemove);
        document.addEventListener('mouseup', handleMouseup);
    }

    function removeMouseListeners() {
        document.removeEventListener('mousemove', handleMousemove);
        document.removeEventListener('mouseup', handleMouseup);
    }

    function handleMousemove(evn: MouseEvent) {
        evn.preventDefault();
        const angle = getNewAngleByEvent(
            evn,
            wrapperRef.current as unknown as HTMLDivElement,
            ANGLE_MODE_BY_MOUSE_MOVE,
        );
        if (typeof angle === 'number') {
            onChange && onChange(angle);
        }
    }

    function handleMouseup(evn: MouseEvent) {
        evn.preventDefault();
        removeMouseListeners();
        const angle = getNewAngleByEvent(
            evn,
            wrapperRef.current as unknown as HTMLDivElement,
            ANGLE_MODE_BY_MOUSE_MOVE,
        );
        if (typeof angle === 'number') {
            onChange && onChange(angle);
        }
    }

    return (
        <div
            ref={wrapperRef}
            className={[prefixCls, className].filter(Boolean).join(' ')}
            style={{
                width,
                height,
                borderRadius: '50%',
                background: 'rgb(255, 255, 255)',
                // boxShadow: 'rgb(0 0 0 / 10%) 0 1px',
                border: '1px solid #ccc',
                position: 'relative',
                ...style,
            }}
            {...other}
            onMouseDown={handleMousedown}
        >
            {React.createElement(pointer || Pointer, {
                prefixCls,
                angle,
                style: {
                    zIndex: 1,
                    transform: `translate(${rotatedPosition.x}px, ${rotatedPosition.y}px)`,
                },
                ...comProps,
            })}
        </div>
    );
};

Angle.displayName = 'Angle';

export default Angle;
